// extracted by mini-css-extract-plugin
module.exports = {"image":"section-mousse-module--image--1BBVp"};